import t from"./_nativeCreate.js";var r=t,a=Object.prototype.hasOwnProperty;var e=function(t){var e=this.__data__;return r?void 0!==e[t]:a.call(e,t)};export{e as default};
//# sourceMappingURL=_hashHas.js.map
